import { API_PATHS } from '@/constants/api-paths'
import { api } from '@/lib/api'

export type BillingPlan = 'trial' | 'free' | 'active' | 'locked'

export interface BillingStatus {
  subscription_status: 'trial' | 'active' | 'expired' | null
  // Computed by the backend: `free` = trial over (or subscription ended) with
  // at most `user_limit` staff users; `locked` = over that limit and unpaid.
  plan?: BillingPlan | null
  trial_start_on?: string | null
  trial_end_on?: string | null
  trial_days_remaining?: number | null
  is_locked: boolean
  lock_reason?: 'trial_ended' | 'subscription_ended' | null
  user_count?: number
  user_limit?: number | null
}

const getObjectPayload = <T>(payload: unknown): T => {
  if (payload && typeof payload === 'object' && 'data' in (payload as Record<string, unknown>)) {
    return (payload as Record<string, unknown>).data as T
  }
  return payload as T
}

export const billingApi = {
  getStatus: async (): Promise<BillingStatus> => {
    const response = await api.get(API_PATHS.billing.status)
    return getObjectPayload<BillingStatus>(response.data)
  },

  createCheckoutSession: async (): Promise<{ checkout_url: string }> => {
    const response = await api.post(API_PATHS.billing.createCheckoutSession)
    return getObjectPayload<{ checkout_url: string }>(response.data)
  },
}
